import React from 'react';
import { Link } from 'react-router-dom';
const DeliveryOrderBanner = () => {
  return (
    <>
       <section className='page-banner-section order-details'>
        <div className='container'>
          <div className='banner-section'>
            <div className='breadcrumb-section'>
              <div className='link'>
                <Link to="/" className="breadcrumb-link">Home</Link>
              </div>
              <div className='seperator'>/</div>
              <div className='link'>
                <div className="breadcrumb-link">cart</div>
              </div>
            </div>
            <div className='page-title'>
              <h1 className='title'>Shopping Cart</h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeliveryOrderBanner;